import { useFormContext, SubmitFormButton, RadioField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FormFooter } from '../styles';
const formFieldsContainerCss = "f19501jv";
const FormFieldsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formFieldsContainerCss, props.className)} />;
});
export const FormContent = () => {
  const {
    values,
    handleReset
  } = useFormContext();
  const {
    create_org_event_type_permission: permission
  } = values;
  const showWarning = permission === 'no_one';
  return <>
      <FormFieldsContainer>
        <RadioField label={I18n.t('publisher.organization_settings.shared_event_types.all_members')} name="create_org_event_type_permission" value="all_members" />
        <RadioField label={I18n.t('publisher.organization_settings.shared_event_types.no_one')} name="create_org_event_type_permission" value="no_one" />
      </FormFieldsContainer>
      {showWarning && <ContextualBanner spacingBottom={24} variant="warning">
          {I18n.t('publisher.organization_settings.shared_event_types.no_one_warning')}
        </ContextualBanner>}
      <FormFooter>
        <Button decoration="secondary-outline" onClick={handleReset}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <SubmitFormButton>
          {I18n.t('publisher.action.save')}
        </SubmitFormButton>
      </FormFooter>
    </>;
};

require("./form_content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");